/**
 * Racine de l'interface : connexion, puis écrans du compte connecté.
 */
import { useEffect, useState } from 'react';
import { EtatVide } from './composants/EtatVide';
import { FournisseurNotifications } from './composants/Notifications';
import type { Compte } from './donnees/authentification';
import { FournisseurDonnees } from './donnees/contexte';
import { creerServices, type Services } from './donnees/services';
import { useTheme } from './donnees/theme';
import { Application } from './Application';
import { EcranConnexion } from './ecrans/EcranConnexion';

export function App() {
  const [services, setServices] = useState<Services | null | undefined>(undefined);
  const theme = useTheme();
  const [compte, setCompte] = useState<Compte | null | undefined>(undefined);
  const [reinitialisation, setReinitialisation] = useState(false);

  useEffect(() => {
    void creerServices().then(setServices);
  }, []);

  useEffect(() => {
    if (!services) return;
    let actif = true;
    void services.auth.compte().then((c) => actif && setCompte(c));
    const arreter = services.auth.surChangement((c, reinit) => {
      setCompte(c);
      if (reinit) setReinitialisation(true);
    });
    return () => {
      actif = false;
      arreter();
    };
  }, [services]);

  let contenu;
  if (services === null) {
    contenu = (
      <div className="fc-fenetre fc-fenetre--seule">
        <header className="fc-fenetre__outils" aria-label="Barre de la fenêtre" />
        <main className="fc-fenetre__principale">
          <EtatVide
            icone="cloud-off"
            niveauTitre={2}
            titre="Projet Supabase non configuré"
            texte="Renseignez VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY (voir .env.example), puis relancez l’application."
            style={{ paddingTop: 'var(--espace-56)' }}
          />
        </main>
      </div>
    );
  } else if (services === undefined || compte === undefined) {
    contenu = <div className="fc-fenetre fc-fenetre--seule" aria-busy="true" />;
  } else if (compte === null || reinitialisation) {
    contenu = (
      <EcranConnexion
        auth={services.auth}
        vueInitiale={reinitialisation ? 'nouveau-mot-de-passe' : 'connexion'}
        onMotDePasseChange={() => setReinitialisation(false)}
      />
    );
  } else {
    contenu = (
      <FournisseurDonnees key={compte.email} services={services} compte={compte}>
        <Application theme={theme} />
      </FournisseurDonnees>
    );
  }
  return <FournisseurNotifications>{contenu}</FournisseurNotifications>;
}
